import React from "react";
import MainLayouts from "../../Layout/MainLayouts";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { ReactComponent as ArrowLeft } from "bootstrap-icons/icons/arrow-left.svg";
import { ReactComponent as PlusCircle } from "bootstrap-icons/icons/plus-circle.svg";
import Spinner from "../spinner/Spinner";
import { useHeadOfficeInventory, useHeadOfficeById } from "../../hooks/useHeadOffice";

const HeadOfficeInventory = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const headOfficeId = searchParams.get("id");

  const { data: headOfficeData } = useHeadOfficeById(headOfficeId);
  const { data: inventoryData, isLoading } = useHeadOfficeInventory(headOfficeId, 100);

  const headOffice = headOfficeData?.data;
  const inventory = inventoryData?.data?.inventory || [];

  return (
    <MainLayouts>
      <div className="p-6">
        <div className="flex justify-between items-center mb-6">
          <div className="flex items-center gap-4">
            <button
              onClick={() => navigate(`/head-office/details?id=${headOfficeId}`)}
              className="text-orange1 hover:text-orange-600"
            >
              <ArrowLeft className="w-6 h-6" />
            </button>
            <div>
              <h1 className="text-2xl font-bold">Inventory</h1>
              <p className="text-gray-500">{headOffice?.name || "Loading..."}</p>
            </div>
          </div>
          <Link
            to={`/head-office/allocate-stock?id=${headOfficeId}`}
            className="flex items-center gap-2 bg-orange1 text-white px-4 py-2 rounded hover:bg-orange-600 transition"
          >
            <PlusCircle className="w-5 h-5" />
            Allocate Stock
          </Link>
        </div>

        {isLoading ? (
          <Spinner loading={isLoading} />
        ) : (
          <div className="bg-white rounded-lg shadow overflow-hidden">
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Product
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Category
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Current Stock
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Reserved
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Available
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Reorder Level
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Status
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Total Received
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Total Allocated
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {inventory.length === 0 ? (
                  <tr>
                    <td colSpan="9" className="px-6 py-4 text-center text-gray-500">
                      No inventory items found
                    </td>
                  </tr>
                ) : (
                  inventory.map((item) => (
                    <tr key={item.id} className="hover:bg-gray-50">
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm font-medium text-gray-900">
                          {item.product_name}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-500">{item.product_category}</div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-900">{item.current_stock}</div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-500">{item.reserved_stock}</div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm font-medium text-gray-900">
                          {item.available_stock}
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-500">{item.reorder_level}</div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        {item.is_out_of_stock ? (
                          <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-red-100 text-red-800">
                            Out of Stock
                          </span>
                        ) : item.is_low_stock ? (
                          <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800">
                            Low Stock
                          </span>
                        ) : (
                          <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
                            In Stock
                          </span>
                        )}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-500">{item.total_received}</div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <div className="text-sm text-gray-500">{item.total_allocated}</div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
        )}
      </div>
    </MainLayouts>
  );
};

export default HeadOfficeInventory;
